{
 "All": "הכול",
 "awaiting deposit": "ממתין למקדמה",
 "Test booking": "תור בדיקה",
 "confirmed": "מאושר",
 "completed": "הגיע/ה",
 "no-show": "לא הגיע/ה",
 "cancelled": "בוטל",
 "Inbox": "תיבת שיחות",
 "Search name or phone": "חיפוש לפי שם או טלפון",
 "No conversations": "אין שיחות",
 "Messages from your channels will appear here.": "הודעות מהערוצים שלכם יופיעו כאן.",
 "Visitor": "מבקר/ת",
 "Pick a conversation": "בחרו שיחה",
 "The AI answers on its own. Conversations that need a person show up under \"Needs a person\".": "ה-AI עונה בעצמו. שיחות שדורשות נציג יופיעו תחת \"דרוש נציג\".",
 "Conversation not found": "השיחה לא נמצאה",
 "Back": "חזרה",
 "←": "→",
 "Handed off: {reason}": "הועבר לנציג: {reason}",
 "You're handling this chat": "השיחה עכשיו בטיפולכם",
 "Take over": "לקחת את השיחה",
 "AI is handling this chat again": "ה-AI מטפל שוב בשיחה",
 "Return to AI": "החזרה ל-AI",
 "AI": "AI",
 "Team": "צוות",
 "Automated": "אוטומטי",
 "Today": "היום",
 "Yesterday": "אתמול",
 "not delivered": "לא נמסרה",
 "read": "נקראה",
 "Type to reply; sending takes the chat over from the AI": "כתבו תשובה; שליחה תעביר את השיחה אליכם מה-AI",
 "Type your reply": "כתבו תשובה",
 "Send": "שליחה",
 "Saved": "נשמר",
 "Customer": "לקוח",
 "Stage": "שלב",
 "Interested in:": "מתעניין/ת ב:",
 "Email:": "אימייל:",
 "Opted out of marketing": "הוסר/ה מדיוור",
 "Recorded {when} ({source})": "נרשם ב-{when} ({source})",
 "Consent recorded": "ההסכמה נרשמה",
 "Consent removed": "ההסכמה הוסרה",
 "Agreed to receive offers": "הסכמה לקבלת הצעות",
 "Notes": "הערות",
 "Save notes": "שמירת הערות",
 "Appointments": "תורים",
 "None yet.": "עדיין אין.",
 "Voice note, transcribed": "הודעה קולית, תומללה",
 "The file is no longer available.": "הקובץ כבר לא זמין.",
 "Photo from the customer": "תמונה מהלקוח",
 "Open the file": "פתיחת הקובץ",
 "Contacts": "אנשי קשר",
 "Every person who messaged you, with where they are in the funnel": "כל מי שפנה אליכם, ובאיזה שלב במשפך הוא נמצא",
 "Search name, phone or email": "חיפוש לפי שם, טלפון או אימייל",
 "No contacts here yet": "אין כאן אנשי קשר עדיין",
 "Name": "שם",
 "Channel": "ערוץ",
 "Interest": "התעניינות",
 "Last message": "הודעה אחרונה",
 "opted out": "הוסר/ה מדיוור",
 "offers ok": "מאשר/ת הצעות",
 "Bookings": "תורים",
 "{from} → {to} · {tz}": "{from} ← {to} · {tz}",
 "← Previous": "→ הקודם",
 "This week": "השבוע",
 "Next →": "הבא ←",
 "New booking": "תור חדש",
 "No bookings this week": "אין תורים השבוע",
 "Bookings made by the AI agent or your team show up here.": "תורים שנקבעו על ידי סוכן ה-AI או הצוות שלכם יופיעו כאן.",
 "Marked as attended": "סומן כהגיע/ה",
 "Attended": "הגיע/ה",
 "Marked as no-show": "סומן כלא הגיע/ה",
 "No-show": "לא הגיע/ה",
 "Cancel this booking?": "לבטל את התור?",
 "Booking cancelled": "התור בוטל",
 "Cancel": "ביטול",
 "Booked": "התור נקבע",
 "Service": "שירות",
 "Choose…": "בחירה…",
 "{name} ({n} min)": "{name} ({n} דק׳)",
 "Day": "יום",
 "Time": "שעה",
 "No free times that day.": "אין שעות פנויות ביום הזה.",
 "Customer name": "שם הלקוח",
 "Book": "קביעת תור",
 "Waitlist": "רשימת המתנה",
 "When a booking is cancelled or moved, the freed slot is offered to the first matching person here.": "כשתור מבוטל או מוזז, המועד שהתפנה מוצע לאדם המתאים הראשון ברשימה.",
 "Wants": "מבקש/ת",
 "Status": "סטטוס",
 "with {name}": "אצל {name}",
 "{from} → {to}, {when}": "{from} ← {to}, {when}",
 "any time": "כל שעה",
 "mornings": "בקרים",
 "afternoons": "צהריים",
 "evenings": "ערבים",
 "offered {when}": "הוצע {when}",
 "offered": "הוצע",
 "waiting": "ממתין/ה",
 "Removed from waitlist": "הוסר/ה מרשימת ההמתנה",
 "Remove": "הסרה",
 "Anyone": "כל אחד",
 "Services & staff": "שירותים וצוות",
 "What customers can book, how long it takes, and who is available when": "מה לקוחות יכולים להזמין, כמה זמן זה לוקח ומי זמין מתי",
 "Add service": "הוספת שירות",
 "Services": "שירותים",
 "No services yet": "אין שירותים עדיין",
 "Add what you offer so the agent can quote prices and book the right length of appointment.": "הוסיפו את מה שאתם מציעים, כדי שהסוכן יוכל לציין מחירים ולקבוע תור באורך הנכון.",
 "Duration": "משך",
 "Price": "מחיר",
 "Performed by": "מבוצע על ידי",
 "hidden": "מוסתר",
 "{n} min": "{n} דק׳",
 "+{n} min buffer": "+{n} דק׳ זמן מאגר",
 "On request": "לפי בקשה",
 "Edit": "עריכה",
 "Staff & calendars": "צוות ויומנים",
 "Add staff member": "הוספת איש צוות",
 "Each staff member (or room) has weekly hours. If you link a Google or Outlook calendar, busy events there block booking and new bookings are added to it.": "לכל איש צוות (או חדר) יש שעות שבועיות. אם מקשרים יומן Google או יומן Outlook, אירועים תפוסים בו חוסמים קביעת תורים, ותורים חדשים נוספים אליו.",
 "Internal calendar only": "יומן פנימי בלבד",
 "closed": "סגור",
 "Service saved": "השירות נשמר",
 "Edit service": "עריכת שירות",
 "New service": "שירות חדש",
 "Description": "תיאור",
 "The agent uses this to recommend the right service.": "הסוכן משתמש בזה כדי להמליץ על השירות המתאים.",
 "Duration (min)": "משך (דק׳)",
 "Buffer after (min)": "זמן מאגר אחרי (דק׳)",
 "Leave empty for 'on request'": "השאירו ריק עבור \"לפי בקשה\"",
 "Currency": "מטבע",
 "Deposit to book": "מקדמה לקביעת תור",
 "Optional. Customers pay it online (card, Bit, Apple Pay) through your Grow account, connected in Settings → Integrations, before the slot is confirmed.": "אופציונלי. הלקוחות משלמים אותה אונליין (כרטיס אשראי, ביט, Apple Pay) דרך חשבון Grow שלכם, שמחובר בהגדרות ← אינטגרציות, לפני שהתור מאושר.",
 "None selected means any staff member.": "אם לא נבחר אף אחד, כל איש צוות יכול לבצע.",
 "Bookable": "זמין להזמנה",
 "Service hidden": "השירות הוסתר",
 "Hide service": "הסתרת שירות",
 "Save": "שמירה",
 "Couldn't read \"{part}\". Use 09:00-13:00, 16:00-19:00": "לא הצלחנו לקרוא את \"{part}\". יש להשתמש בפורמט 09:00-13:00, 16:00-19:00",
 "Edit staff member": "עריכת איש צוות",
 "New staff member": "איש צוות חדש",
 "Google Calendar": "יומן Google",
 "Calendar": "יומן",
 "Busy times in this calendar block bookings.": "זמנים תפוסים ביומן הזה חוסמים קביעת תורים.",
 "Connect a Google or Outlook calendar in Settings → Integrations to sync.": "לסנכרון, חברו יומן Google או יומן Outlook בהגדרות ← אינטגרציות.",
 "Don't sync": "ללא סנכרון",
 "{name} (primary)": "{name} (ראשי)",
 "calendar id (optional)": "מזהה יומן (אופציונלי)",
 "Weekly hours": "שעות שבועיות",
 "Format: 09:00-13:00, 16:00-19:00. Leave empty for closed.": "פורמט: 09:00-13:00, 16:00-19:00. השאירו ריק ליום סגור.",
 "Removed": "הוסר",
 "Sunday": "ראשון",
 "Monday": "שני",
 "Tuesday": "שלישי",
 "Wednesday": "רביעי",
 "Thursday": "חמישי",
 "Friday": "שישי",
 "Saturday": "שבת",
 "Sun": "א׳",
 "Mon": "ב׳",
 "Tue": "ג׳",
 "Wed": "ד׳",
 "Thu": "ה׳",
 "Fri": "ו׳",
 "Sat": "ש׳",
 "Checked in": "נרשמה הגעה",
 "Checked in. The customer got their last visit's summary and progress link": "נרשמה הגעה. הלקוח/ה קיבל/ה את הסיכום מהביקור הקודם ואת קישור ההתקדמות",
 "Checked in. No earlier visit summary to send yet": "נרשמה הגעה. עוד אין סיכום ביקור קודם לשליחה",
 "Checked in. No phone or chat on this booking to send the summary to": "נרשמה הגעה. אין לתור הזה טלפון או צ׳אט לשליחת הסיכום",
 "Checked in. Automated messages are paused, so nothing was sent": "נרשמה הגעה. ההודעות האוטומטיות מושהות, ולכן לא נשלח דבר",
 "Checked in, but the summary couldn't reach the customer": "נרשמה הגעה, אבל הסיכום לא הגיע ללקוח/ה",
 "Arrived {time}": "הגיע/ה {time}",
 "Customer confirmed": "הלקוח/ה אישר/ה הגעה",
 "Not confirmed yet": "טרם אושרה הגעה",
 "Summary ready": "יש סיכום",
 "Arrived": "רישום הגעה",
 "Edit visit summary": "עריכת סיכום הביקור",
 "Write visit summary": "כתיבת סיכום ביקור",
 "Summary approved": "הסיכום אושר",
 "Notes saved": "ההערות נשמרו",
 "Visit summary": "סיכום ביקור",
 "Your notes": "ההערות שלך",
 "For the team only. Never sent to the customer.": "לצוות בלבד. לעולם לא נשלחות ללקוח/ה.",
 "What was done, how it went, what's next": "מה נעשה, איך זה הלך, מה הלאה",
 "Draft the customer's summary with AI": "ניסוח הסיכום ללקוח/ה עם AI",
 "What the customer sees": "מה שהלקוח/ה רואה",
 "Sent when they check in for their next visit, and kept on their progress page. Check it before you approve.": "נשלח כשהלקוח/ה מגיע/ה לביקור הבא, ונשמר בדף ההתקדמות שלו/ה. כדאי לבדוק לפני האישור.",
 "Approve summary": "אישור הסיכום",
 "Customer's mobile": "הנייד של הלקוח/ה",
 "They get a confirmation now and a reminder the day before.": "יקבלו אישור עכשיו ותזכורת יום לפני.",
 "The customer already got their last visit's summary": "הלקוח/ה כבר קיבל/ה את הסיכום מהביקור הקודם",
 "Resend summary": "שליחת הסיכום שוב",
 "Next task": "המעקב הבא",
 "via {source}": "דרך {source}",
 "Not recorded": "לא תועד",
 "Owner updated": "האחראי עודכן",
 "Unassigned": "ללא אחראי",
 "Came from:": "הגיע/ה מ:",
 "Tasks": "מעקבים",
 "Today, then the last 30 days": "היום, ואחר כך 30 הימים האחרונים",
 "rebook after {n}d": "קביעה חוזרת אחרי {n} ימים",
 "deposit {amount}": "מקדמה {amount}",
 "Invite to book again after (days)": "הזמנה לקבוע שוב אחרי (ימים)",
 "e.g. 180 for a cleaning, 28 for a haircut. Empty: no rebook invitation. Turn invitations on under AI agent → After the visit.": "למשל 180 לניקיון, 28 לתספורת. ריק: אין הזמנה לקבוע שוב. את ההזמנות מפעילים תחת סוכן AI ← אחרי הביקור.",
 "Reschedule": "שינוי מועד",
 "Booking moved": "התור הועבר",
 "now {when}": "כעת {when}",
 "Pick a new time": "בחרו מועד חדש",
 "Move to {when}": "העברה ל{when}",
 "No free times this week. Try the next one.": "אין מועדים פנויים בשבוע הזה. נסו את השבוע הבא.",
 "The free times couldn't be loaded. If this service was switched off in Services & staff, turn it back on first.": "לא הצלחנו לטעון את המועדים הפנויים. אם השירות הושבת בשירותים וצוות, הפעילו אותו מחדש קודם.",
 "That time was just taken. The booking wasn't moved; pick another time.": "המועד הזה נתפס הרגע. התור לא הועבר; בחרו מועד אחר.",
 "This booking can no longer be moved: it was cancelled, completed or marked as a no-show. Reload the page to see its status.": "אי אפשר להעביר את התור הזה עוד: הוא בוטל, הושלם או סומן כלא הגיע/ה. רעננו את הדף כדי לראות את הסטטוס שלו.",
 "This booking no longer exists. Reload the page.": "התור הזה כבר לא קיים. רעננו את הדף.",
 "This booking's service was removed or switched off, so it can't be moved. Turn the service back on in Services & staff.": "השירות של התור הזה הוסר או הושבת, ולכן אי אפשר להעביר אותו. הפעילו את השירות מחדש בשירותים וצוות.",
 "This service is no longer offered the way this booking was made. Check the service in Services & staff.": "השירות כבר לא ניתן באופן שבו התור הזה נקבע. בדקו את השירות בשירותים וצוות.",
 "The booking couldn't be moved. Try again.": "לא הצלחנו להעביר את התור. נסו שוב.",
 "Mark this number as personal? The AI stops answering it, nothing more from it is stored, and the chat closes. You can undo it under Channels → Known numbers.": "לסמן את המספר הזה כאישי? ה-AI יפסיק לענות לו, שום דבר נוסף ממנו לא יישמר, והשיחה תיסגר. אפשר לבטל את זה בערוצים ← מספרים מוכרים.",
 "Marked personal": "סומן כאישי",
 "This is personal, stop the AI here": "זו שיחה אישית, לעצור כאן את ה-AI",
 "appointments today": "תורים היום",
 "chats waiting for a person": "שיחות שממתינות לנציג",
 "tasks due": "מעקבים לביצוע",
 "{n} overdue": "{n} באיחור",
 "past visits to mark": "ביקורים שעברו לסימון",
 "Attended or no-show?": "הגיע/ה או לא הגיע/ה?",
 "Yesterday: {chats} new chats, {booked} booked by AI{value}, {cancelled} cancelled, {noShows} no-shows": "אתמול: {chats} שיחות חדשות, {booked} תורים שקבע ה-AI{value}, {cancelled} ביטולים, {noShows} לא הגיעו",
 "Where leads come from": "מאיפה מגיעים הלידים",
 "First touch of each new contact: UTM tags and referrer on the website chat, Click-to-WhatsApp and Messenger ads, m.me links.": "נקודת המגע הראשונה של כל איש קשר חדש: תגיות UTM והמפנה בצ׳אט שבאתר, מודעות שמובילות לוואטסאפ ולמסנג׳ר, וקישורי m.me.",
 "Source": "מקור",
 "Leads": "לידים",
 "Made a booking": "קבעו תור",
 "Became customers": "הפכו ללקוחות",
 "Booking rate": "שיעור קביעת תורים",
 "Direct / unknown": "ישיר / לא ידוע",
 "Meta ads": "מודעות מטא",
 "Meta post": "פוסט במטא",
 "m.me link": "קישור m.me",
 "Follow-ups your team promised customers": "מעקבים שהצוות שלכם הבטיח ללקוחות",
 "Mine": "שלי",
 "Anyone's": "של כולם",
 "Overdue": "באיחור",
 "Tomorrow": "מחר",
 "Later": "בהמשך",
 "Nothing to follow up": "אין מעקבים פתוחים",
 "Add a task from a conversation's customer panel (\"Call back tomorrow\", \"Send the price list\").": "הוסיפו מעקב מחלונית הלקוח שבתוך השיחה (\"לחזור מחר\", \"לשלוח מחירון\").",
 "Task done": "המעקב בוצע",
 "Task added": "המעקב נוסף",
 "No open tasks.": "אין מעקבים פתוחים.",
 "New task": "מעקב חדש",
 "Call back about the price": "לחזור בטלפון לגבי המחיר",
 "Add task": "הוספת מעקב",
 "In 2 hours": "בעוד שעתיים",
 "Tomorrow 10:00": "מחר ב-10:00",
 "In 3 days": "בעוד 3 ימים",
 "Next week": "בשבוע הבא",
 "Customers waiting for a time to open. When a booking is cancelled or moved, the agent offers the slot to matching customers.": "לקוחות שמחכים שיתפנה מועד. כשתור מתבטל או זז, הסוכן מציע את המועד ללקוחות המתאימים.",
 "offered {n}×": "הוצע {n} פעמים",
 "Value": "ערך",
 "AI budget this month: ${spent} of ${cap}.": "תקציב ה-AI החודש: ${spent} מתוך ${cap}.",
 "Used up: new messages go to “Needs a person” until it is raised or the month ends.": "התקציב נוצל: הודעות חדשות עוברות ל\"דרוש נציג\" עד שיוגדל או עד סוף החודש.",
 "Ask your RELAYZA contact to change it.": "לשינוי, פנו לאיש הקשר שלכם ב-RELAYZA."
}
